(() => {
  if (customElements.get('hs-bed-linen-guide')) return;
  let nextId = 0;
  class CollectionSizeGuide extends HTMLElement {
    connectedCallback() {
      if (this.dialog) return;
      const template = this.querySelector('template');
      this.trigger = this.querySelector('[data-guide-open]');
      if (!template || !this.trigger) return;
      this.dialog = template.content.querySelector('dialog').cloneNode(true);
      document.body.append(this.dialog);
      this.productContainer = this.closest('.product-section') || this.closest('[data-product-id]');
      // Move only the button; keep the guide component and its dialog lifecycle in place.
      this.placeQuantityLink = () => {
        if (this.quantitySlot || !this.isConnected) return;
        const quantity = this.productContainer?.querySelector('.product__quantity');
        if (!quantity || quantity.querySelector('.hs-quantity-guide-slot')) return;
        this.triggerAnchor = document.createComment('Size guide original position');
        this.trigger.before(this.triggerAnchor);
        this.quantitySlot = document.createElement('div');
        this.quantitySlot.className = 'hs-quantity-guide-slot';
        quantity.classList.add('hs-quantity-with-guide');
        quantity.append(this.quantitySlot);
        this.quantitySlot.append(this.trigger);
        this.quantityContainer = quantity;
        this.originalGuideRow = this.closest('.hs-size-options-row__guide, .size-chart__standalone');
        this.originalGuideRow?.classList.add('hs-guide-link-relocated');
      };
      this.placeQuantityLink();
      // Also cover themes that render their quantity block after the variant picker.
      if (typeof window !== 'undefined') {
        this.placementFrame = window.requestAnimationFrame(this.placeQuantityLink);
      }
      const tabs = Array.from(this.dialog.querySelectorAll('[data-guide-tab]'));
      const sections = Array.from(this.dialog.querySelectorAll('[data-guide-section]'));
      const id = `hs-guide-${++nextId}`;
      this.dialog.id = id;
      this.trigger.setAttribute('aria-controls', id);
      this.trigger.setAttribute('aria-expanded', 'false');
      tabs.forEach((tab, i) => {
        tab.id = `${id}-tab-${i}`;
        const panel = sections.find(s => s.dataset.guideSection === tab.dataset.guideTab);
        if (panel) {
          panel.id = `${id}-panel-${i}`;
          panel.setAttribute('aria-labelledby', tab.id);
          tab.setAttribute('aria-controls', panel.id);
        }
      });
      this.unit = 'in';
      this.activeKey = sections.find(s => !s.hidden)?.dataset.guideSection || sections[0]?.dataset.guideSection;
      const unitCells = Array.from(this.dialog.querySelectorAll('[data-in][data-cm]'));
      const customUnits = this.dialog.querySelector('[data-custom-units]');
      if (customUnits) customUnits.hidden = unitCells.length === 0;
      this.setUnit = unit => {
        if (unit !== 'in' && unit !== 'cm') return;
        this.unit = unit;
        unitCells.forEach(cell => { cell.textContent = cell.dataset[unit].split(' / ').join('\n'); });
        this.dialog.querySelectorAll('[data-guide-unit]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.guideUnit === unit)));
        const suffix = unit === 'in' ? 'inches' : 'cm';
        sections.forEach(s => s.querySelectorAll('[data-guide-dimension-heading]').forEach(h => { h.textContent = `${s.dataset.guideMeasure || 'Dimensions'} (${suffix})`; }));
        const active = sections.find(s => s.dataset.guideSection === this.activeKey);
        const note = this.dialog.querySelector('.hs-linen-guide__unit-note');
        if (note) note.textContent = `${active?.dataset.guideMeasure || 'Dimensions'} (${suffix})`;
      };
      this.chooseTab = key => {
        if (!sections.some(s => s.dataset.guideSection === key)) return;
        this.activeKey = key;
        sections.forEach(s => { s.hidden = s.dataset.guideSection !== key; });
        tabs.forEach(t => {
          const active = t.dataset.guideTab === key;
          t.setAttribute('aria-selected', String(active));
          t.tabIndex = active ? 0 : -1;
        });
        this.setUnit(this.unit);
      };
      const chooseSet = picker => {
        const section = picker.closest('[data-guide-section]');
        section?.querySelectorAll('[data-guide-set]').forEach(s => { s.hidden = s.dataset.guideSet !== picker.value; });
      };
      this.dialog.querySelectorAll('[data-guide-set-picker]').forEach(picker => {
        picker.addEventListener('change', () => chooseSet(picker));
        chooseSet(picker);
      });
      const setButtons = Array.from(this.dialog.querySelectorAll('[data-guide-set-button]'));
      const chooseButtonSet = (button) => {
        const section = button.closest('[data-guide-section]');
        section?.querySelectorAll('[data-guide-set]').forEach(set => { set.hidden = set.dataset.guideSet !== button.dataset.guideSetButton; });
        setButtons.filter(other => other.closest('[data-guide-section]') === section).forEach(other => { other.setAttribute('aria-pressed', String(other === button)); });
      };
      setButtons.forEach(button => button.addEventListener('click', () => chooseButtonSet(button)));
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.chooseTab(tab.dataset.guideTab));
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = tabs[(i + 1) % tabs.length];
          if (event.key === 'ArrowLeft') target = tabs[(i + tabs.length - 1) % tabs.length];
          if (event.key === 'Home') target = tabs[0];
          if (event.key === 'End') target = tabs[tabs.length - 1];
          if (!target) return;
          event.preventDefault();
          this.chooseTab(target.dataset.guideTab);
          target.focus();
        });
      });
      this.openGuide = () => {
        if (this.dialog.open) return;
        this.setUnit('in');
        let options = [];
        try { options = JSON.parse(this.dataset.selectedOptions || '[]'); } catch (_) { /* Keep the default set. */ }
        const current = this.productContainer?.querySelectorAll('.variant-input-wrap input:checked, .variant-input-wrap select');
        if (current?.length) options = Array.from(current).map(input => input.value);
        this.dialog.querySelectorAll('[data-guide-set-picker]').forEach(picker => {
          const match = Array.from(picker.options).find(o => options.includes(o.value));
          if (match) { picker.value = match.value; chooseSet(picker); }
        });
        const selectedSetButton = setButtons.find(button => options.includes(button.dataset.guideSetButton));
        if (selectedSetButton) chooseButtonSet(selectedSetButton);
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.trigger.setAttribute('aria-expanded', 'true');
        this.dialog.querySelector('[data-guide-close]').focus();
      };
      this.restorePage = () => {
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.trigger.isConnected) this.trigger.focus();
      };
      this.trigger.addEventListener('click', this.openGuide);
      this.dialog.querySelector('[data-guide-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', this.restorePage);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      this.dialog.querySelectorAll('[data-guide-unit]').forEach(b => b.addEventListener('click', () => this.setUnit(b.dataset.guideUnit)));
      this.chooseTab(this.activeKey);
    }
    disconnectedCallback() {
      if (!this.dialog) return;
      if (typeof window !== 'undefined') window.cancelAnimationFrame(this.placementFrame);
      if (this.dialog.open) {
        this.dialog.removeEventListener('close', this.restorePage);
        this.dialog.close();
        this.restorePage();
      }
      this.trigger.removeEventListener('click', this.openGuide);
      if (this.triggerAnchor) {
        this.triggerAnchor.replaceWith(this.trigger);
        this.triggerAnchor = null;
      }
      this.quantitySlot?.remove();
      this.quantitySlot = null;
      this.quantityContainer?.classList.remove('hs-quantity-with-guide');
      this.originalGuideRow?.classList.remove('hs-guide-link-relocated');
      this.dialog.remove();
      this.dialog = null;
    }
  }
  customElements.define('hs-bed-linen-guide', CollectionSizeGuide);
})();
